import React from 'react';

const ApkDropHero = () => {
  // Import the existing ApkDropHero component
  const OriginalApkDropHero = require('../../components/ApkDropHero').default;
  
  return <OriginalApkDropHero />;
};

export default ApkDropHero; 